var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-reports',{attrs:{"headers":_vm.headers,"update":_vm.loadData,"data":_vm.data,"show-total":"","numPages":_vm.numPages,"data_loading":_vm.data_loading,"workgroup-order":""},on:{"change-pagination":_vm.changePagination},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }